module.exports = __webpack_public_path__ + "img/rotate.42c9fb8d.svg";